import React from 'react'
import Button from '../components/Button'
import { IconPlus, IconCross } from '../components/icons'
import { AnalyticsContext } from '../analytics/AnalyticsContext'


const AddRoomRow: React.FunctionComponent<{
  onAddRoom: (name: string) => void
  onChangeRoomName: (value: string) => void
  editingRoomName: string
  onChangeEditMode: (editimg: boolean) => void
  editing: boolean
}> = ({
  onAddRoom,
  onChangeRoomName,
  editingRoomName,
  onChangeEditMode,
  editing,
}) => {
  const analyticsLogger = React.useContext(AnalyticsContext)
  const newRoomNameRef = React.useRef<HTMLInputElement | null>(null)

  return (
    <div className="AddRoomRow">
      {
        !editing ? (
          <div className="name">
            <Button
              buttonStyle="green"
              onClick={() => {
                analyticsLogger.log({
                  event: 'cta_click',
                  cta_name: 'Add a Room',
                  cta_link: null,
                  cta_category: 'Button',
                  cta_location: 'My list'
                })

                onChangeEditMode(true)
              }}

            >
              <img src={IconPlus} alt="+" style={{ filter: 'brightness(100)', marginRight: '8px' }} />
              Add a Room
            </Button>
          </div>
        ) : (
          <div className="name editing">
            <input
              className="roomInput"
              placeholder="Add a Room"
              ref={el => {
                if (newRoomNameRef.current !== el && el != null) {
                  el.focus()
                }

                newRoomNameRef.current = el
              }}
              type="text"
              value={editingRoomName}
              onChange={e => onChangeRoomName(e.target.value)}
            />
            <Button
              buttonStyle="green"
              disabled={editingRoomName.trim().length === 0}
              onClick={() => onAddRoom(editingRoomName.trim())}
            >
              Done
            </Button>
            <Button
              buttonStyle="redStroke"
              round
              onClick={() => onChangeEditMode(false)}
            >
              <img src={IconCross} alt="Cancel" />
            </Button>
          </div>
        )
      }
    </div>
  )
}

export default AddRoomRow
